const annualPricePerSqFt = (
  dimension1: number,
  dimension2: number,
  monthlyPrice: number
) => {
  return (monthlyPrice * 12) / (dimension1 * dimension2);
};

export { annualPricePerSqFt };
